import { analyticsUtils } from '../../../utils';

export const clickEvent = (text: string | undefined, element: string | undefined) =>
  analyticsUtils.sendEvent('GA:clickButton', {
    elementType: 'button',
    elementBlock: 'Catalogue', // блок, в котором расположен элемент
    elementName: `${element}`, // условное название элемента
    elementText: `${text}`, // текст отдела
  });
